/**
 * TODO isMobile: true mode
 * TODO locale
 */
import "air-datepicker/air-datepicker.css";
import AirDatepicker from "air-datepicker";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";

interface Range {
  from: Date | null;
  till: Date | null;
}

interface Props {
  name?: string;
  placeholder?: string;
  value?: Range | null;
  onChange?: (datesRange: Range) => void;
  options?: object | null;
  checkDateSelectable?: ((date: Date) => boolean)|null
}


const DateRangePicker: React.FC<Props> = (
  {
    name,
    placeholder = "",
    value = { from: null, till: null },
    onChange = (range) => {},
    options,
    checkDateSelectable = null,
  }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const datePicker = useRef<AirDatepicker<HTMLInputElement>>();

  // Start init
  useEffect(() => {
    if (inputRef.current === null) {
      console.error("Null ref");
      return;
    }

    const theOptions = {
      ...options,
      range: true,
      multipleDatesSeparator: ' - ',
      onSelect: (e) => {
        onChange({
          from: e.date[0] ?? null,
          till: e.date[1] ?? null
        });
      },

    };

    if (checkDateSelectable !== null ) {
      // We still need to allow to modify currently selected range
      const isDateWithinAlreadySelectedRange = (date: Date, datepicker) => {
        const rangeStart = datepicker.selectedDates[0] ?? null;
        const rangeEnd = datepicker.selectedDates[1] ?? null;

        if (rangeStart === null || rangeEnd === null) {
          return false;
        }

        if (rangeStart && date < rangeStart) {
          return false;
        }

        if (rangeEnd && date > rangeEnd) {
          return false;
        }

        return true;
      }

      theOptions.onBeforeSelect = ({date, datepicker}) => {
        // Dont allow user to select date, if disabled date is in the range
        return isDateWithinAlreadySelectedRange(date, datepicker) || checkDateSelectable(date);
      };

      // Style selected range with grayed out background, when not selectable dates are in the range
      theOptions.onFocus = ({date, datepicker}) => {
        if (isDateWithinAlreadySelectedRange(date, datepicker) || checkDateSelectable(date)) {
          datepicker.$datepicker.classList.remove('-disabled-range-')
        } else {
          datepicker.$datepicker.classList.add('-disabled-range-')
        }
      };

      // Style not selectable dates
      theOptions.onRenderCell = ({date, datepicker}) => {
        if (!isDateWithinAlreadySelectedRange(date, datepicker) && !checkDateSelectable(date)) {
          return {
            disabled: true
          }
        }
      };
    }

    // Init datepicker
    datePicker.current = new AirDatepicker<HTMLInputElement>(inputRef.current, theOptions);

    if (value !== null && value.from !== null && value.till !== null) {
      datePicker.current.selectDate([value.from, value.till]);
    }
  }, []);

  useEffect(() => {
    // Update if props are changed
    datePicker.current?.update({ ...options });
  }, [options]);

  return (
    <input
      ref={inputRef}
      type="text"
      id={name}
      name={name}
      placeholder={placeholder}
      // defaultValue={selectedRange}
      className={clsx(
        "block px-11",
        {
          // "invalid": isInvalid, // TODO Implement
          "invalid": false
        }
      )}
    />
  );
};

export default DateRangePicker;
